<template>
	<div class="addmeals" v-if="isload" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
		<el-form :inline="true" size="mini" label-width="120" style="margin-top:10px;margin-left:20px;" v-if="active==0">
			<el-form-item :label="infolang.cargotype">
				<el-radio-group v-model="orderinfo.cargotype">
				    <el-radio :label="item.value" v-for="(item,index) in cargotypelist" :key="index">{{item.label}}</el-radio>
				</el-radio-group>
			</el-form-item>
		</el-form>
		<el-form v-show="active==0">
			<el-row >
				<maininfo :ref="'maininfo_'+l_id" :item="item" :l_id="l_id"></maininfo>
			</el-row>
		</el-form>		
		<!-- 普通商品 -->
		<el-card class="box-card" shadow="hover" v-show="orderinfo.cargotype=='1'&&active==0">
			<div slot="header" class="clearfix">
				<span>{{infolang.specset }}</span>
			</div>
			<div style="height:40px;">
				<el-button size="mini" type="warning" @click.native="openspec">{{infolang.addspec}}</el-button>
			</div>
			<pl-table :data="speclist" :header-cell-style="{ background: '#f5f5f5', color: '#606266', textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }"
			:cell-style="{ padding: '0px',height:'40px' }" style="width:80%" :key="combochange" >
				<pl-table-column :label="infolang.t_type" width="180">
					  <template slot-scope="scope">
						  <span>{{scope.row.t_type}}</span>
					  </template>
				</pl-table-column>
				<pl-table-column
				      :label="infolang.t_name">
				      <template slot-scope="scope">
						 <span>{{scope.row.t_name}}</span>
				      </template>
				</pl-table-column>
				<pl-table-column
				      :label="infolang.price"
				      width="100">
				      <template slot-scope="scope">
						  <el-input v-model="scope.row.addprice" type="number" :key="scope.$index"
							  @input="inputchange" size="mini"></el-input>
				      </template>
				</pl-table-column>
				<pl-table-column width="200">
				      <template slot-scope="scope">
						  <i class="el-icon-top" style="cursor: pointer;margin-right:15px;color: #1c9dff;font-size:15pt;" v-if="scope.$index>0" @click="changechunkindex(speclist,scope.$index,'top')"></i> 
						  <i style="margin-right:15px;cursor: pointer;color: #ffaa00; font-size:15pt;" class="el-icon-bottom" v-if="scope.$index<speclist.length" @click="changechunkindex(speclist,scope.$index,'bottom')"></i>
						  <i style="cursor: pointer; color: #f72b10;font-size:15pt;" class="el-icon-delete" @click="delchunk(speclist,scope.$index)"></i>
				      </template>
				</pl-table-column>
			</pl-table>
		</el-card>
		<el-card class="box-card" shadow="hover" v-show="orderinfo.cargotype=='1'&&active==0">
			<div slot="header" class="clearfix">
				<span>{{infolang.stuffset }}</span>
			</div>
			<div style="height:40px;">
				<el-button size="mini" type="warning" @click.native="openstuff">{{infolang.addstuff}}</el-button>
			</div>
			<pl-table :data="stufflist" :header-cell-style="{ background: '#f5f5f5', color: '#606266', textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }"
			:cell-style="{ padding: '0px',height:'40px' }" style="width:80%" :key="combochange" >
				<pl-table-column
				      :label="infolang.a_type"
				      width="180">
				      <template slot-scope="scope">
						  <span>{{scope.row.a_type}}</span>
				      </template>
				</pl-table-column>
				<pl-table-column
				      :label="infolang.ismul"
				      width="150">
				      <template slot-scope="scope">
						  <span>{{scope.row.ismul1}}</span> 
				      </template>
				</pl-table-column>
				<pl-table-column 
				      :label="infolang.a_name">
				      <template slot-scope="scope">
						  <span>{{scope.row.a_name}}</span>
				      </template>
				</pl-table-column>
				<pl-table-column
				      :label="infolang.isaddprice"
				      width="100">
				      <template slot-scope="scope">
						  <span v-if="scope.row.isaddprice=='1'">{{infolang.addprice}}</span>
						  <span v-if="scope.row.isaddprice=='0'">{{infolang.normalprice}}</span>
				      </template>
				</pl-table-column>
				<pl-table-column
				      :label="infolang.price"
				      width="100">
				      <template slot-scope="scope">
						  <el-input :disabled="scope.row.isaddprice=='0'" v-model="scope.row.price" type="number" size="mini"></el-input>
				      </template>
				</pl-table-column>
				<pl-table-column width="200">
				      <template slot-scope="scope">
						  <i class="el-icon-top" style="margin-right:15px;cursor: pointer;color: #1c9dff;font-size:15pt;" v-if="scope.$index>0" @click="changechunkindex(stufflist,scope.$index,'top')"></i> 
						  <i style="margin-right:15px;cursor: pointer;color: #ffaa00;font-size:15pt;" class="el-icon-bottom" v-if="scope.$index<stufflist.length" @click="changechunkindex(stufflist,scope.$index,'bottom')"></i>
						  <i class="el-icon-delete" style="color: #f72b10;font-size:15pt;" @click="delchunk(stufflist,scope.$index)"></i>
				      </template>
				</pl-table-column>
			</pl-table>
		</el-card>
		<!-- 套餐商品 -->
		<el-card class="box-card" shadow="hover" v-show="orderinfo.cargotype=='2'&&active==0" style="margin-top:10px">
			<div slot="header" class="clearfix">
				<span style="margin-right:10px;">{{infolang.comboset }}</span>
				<el-button size="mini" type="primary" plain @click.native="addcomboset">{{infolang.addcomboset}}</el-button>
			</div>
			<div v-for="(item,index) in combolist" :key="index">
				<el-row>
					<el-form :inline="true" size="mini">
						<el-form-item label-width="120" :label="infolang.comboname+'-'+(index+1)">
							
						</el-form-item>
						<el-form-item label-width="100" :label="infolang.comboname">
							<el-input v-model="item.m_name" style="width:300px"></el-input>
						</el-form-item>
						<el-form-item label-width="100" :label="infolang.combotype">
							<el-select v-model="item.combotype" style="width:150px" @change="combotypechange(item,index)">
								<el-option
								      v-for="it in combotypelist"
								      :key="it.value"
								      :label="it.label"
								      :value="it.value">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- 套餐内商品为可选搭配时显示 -->
						<el-form-item label-width="120" label="*" v-if="item.combotype=='0'">
							<el-input v-model="item.sortmaxcount" @change="checkrequired(item,index)">
							    <template slot="prepend">{{item.combocargolist.length}}</template>
							  </el-input>
						</el-form-item>
						<el-form-item label-width="100" v-if="item.combotype=='0'">
							<el-checkbox v-model="item.ismustrepeat" @change="checkrepeat(item,'num')">{{infolang.isrepeat}}</el-checkbox>
						</el-form-item>
					</el-form>
				</el-row>
				<pl-table :data="item.combocargolist" 
				fixedColumnsRoll
				bigDataCheckbox
				:excess-rows="5"
				:highlight-current-row="false"
				inverse-current-row
				header-align="center"
				use-virtual
				:header-cell-style="{ background: '#f5f5f5', color: '#606266', textAlign: 'center', paddingTop: '8px', paddingBottom: '8px' }"
				:cell-style="{ padding: '0px',height:'40px' }" 
				style="width:98%" height="300" :key="combochange">
					<pl-table-column key="1"
					      :label="infolang.cno"
					      width="180">
					      <template slot-scope="scope">
							  <span>{{scope.row.cno}}</span>
					      </template>
					</pl-table-column>
					<pl-table-column key="2"
					      :label="infolang.cname">
					      <template slot-scope="scope">
							  <span>{{scope.row.cname}}</span>
					      </template>
					</pl-table-column>
					<pl-table-column key="3"
					      :label="infolang.cargoprice"
					      width="100">
					      <template slot-scope="scope">
							  <span>{{scope.row.outprice}}</span>
					      </template>
					</pl-table-column>
					<pl-table-column key="4"
					      :label="infolang.num"
					      width="100">
					      <template slot-scope="scope">
							  <el-input v-model="scope.row.num" size="mini" :key="scope.$index"
							  @input="inputchange(item,scope.row,'num')"></el-input>
					      </template>
					</pl-table-column>
					<pl-table-column key="5"
					      :label="infolang.cargocomboprice"
					      width="120">
					      <template slot-scope="scope">
							  <el-input v-model="scope.row.comboprice" size="mini"  :key="scope.$index" 
							  @input="inputchange"></el-input>
					      </template>
					</pl-table-column>
					<pl-table-column key="6"
					      :label="infolang.isrequired"
					      width="100" align="center">
					      <template slot-scope="scope">
							  <el-checkbox :disabled="item.combotype=='1'" :key="scope.$index"  
							  @change="changerequired(scope.row.required,item,scope.$index,index)" 
							  v-model="scope.row.required"></el-checkbox>
					      </template>
					</pl-table-column>
					<pl-table-column key="7"
					      :label="infolang.handle"
					      width="180">
					      <template slot-scope="scope">
							  <i class="el-icon-top" style="font-size:15pt;color: #1c9dff;cursor: pointer;margin-right:15px;" v-if="scope.$index>0" @click="changechunkindex(item.combocargolist,scope.$index,'top')"></i> 
							  <i style="font-size:15pt;color: #ffaa00;cursor: pointer; margin-right:15px;" v-if="scope.$index<item.combocargolist.length" class="el-icon-bottom" @click="changechunkindex(item.combocargolist,scope.$index,'bottom')"></i>
							  <i style="font-size:15pt;color: #f72b10;cursor: pointer; " class="el-icon-delete" @click="delchunk(item.combocargolist,scope.$index)"></i>
					      </template>
					</pl-table-column>
				</pl-table>
				<div style="height:40px;margin-top:10px;">
				    <el-button size="mini" type="primary" @click.native="openselectcargo(index)">{{infolang.selectcombocargo}}</el-button>
					<el-button style="margin-left:10px;" size="mini" type="danger" @click.native="delchunk(combolist,index)">{{infolang.removecombo}}</el-button>
					<el-button style="margin-left:10px;" type="primary" icon="el-icon-top" size="mini" v-if="index>0" circle @click.native="changechunkindex(combolist,index,'top')"></el-button>
					<el-button style="margin-left:10px;" type="warning" icon="el-icon-bottom" size="mini" v-if="index<combolist.length" circle @click.native="changechunkindex(combolist,index,'bottom')"></el-button>
				</div>
			</div>
		</el-card>
		
		<el-card class="box-card" v-loading="picloading" v-show="active == 1">
			<div slot="header" class="clearfix"><span>{{infolang.picset}}</span></div>
			<el-row>
				<el-col :span="12">
					<el-form label-width="100px" size="mini">
						<el-form-item :label="infolang.cargopic">
							<el-upload
								class="avatar-uploader"
								action="#"
								:show-file-list="false"
								:on-change="searchPicChange"
								:limit="1"
								accept="image/*"
								ref="upload"
								v-model="orderinfo.search_pic"
								style="padding-left:10px"
							>
								<i class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="10">
					<el-carousel arrow="nerver" height="215px" indicator-position="none">
						<el-carousel-item>
							<el-card shadow="never" class="box-card" v-if="search_pic != ''" style="margin-top:1px;" :body-style="{ padding: '0px' }">
								<div slot="header" class="clearfix">
									<div class="headtitle"><i class="el-icon-delete Danger" @click="delfile(0)"></i></div>
								</div>
								<div class="block divimage">
									<el-image :src="search_pic.src">
										<div slot="error" class="image-slot el-image_icon"><i class="el-icon-picture-outline"></i></div>
									</el-image>
								</div>
							</el-card>
							<div class="block divimage" v-if="search_pic == ''"><p>{{infolang.nopicture}}</p></div>
						</el-carousel-item>
					</el-carousel>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form label-width="108px" size="mini">
						<el-form-item :label="infolang.cargobanner">
							<el-upload
								class="avatar-uploader"
								action="#"
								:show-file-list="false"
								:on-change="BannerChange"
								accept="image/*"
								ref="banner_pic"
								:multiple="true"
								v-model="banner_piclist"
							>
								<i class="el-icon-plus avatar-uploader-icon"></i>
							</el-upload>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="10">
					<el-carousel arrow="nerver" height="215px" :autoplay="false" indicator-position="none">
						<el-carousel-item v-for="(item, index) in banner_pic" :key="index">
							<el-card shadow="never" class="box-card" :body-style="{ padding: '0px' }">
								<div slot="header" class="clearfix">
									<div class="headtitle"><i class="el-icon-delete Danger" @click="delbanner(item)"></i></div>
								</div>
								<div class="block divimage">
									<el-image :src="item.src">
										<div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
									</el-image>
								</div>
							</el-card>
						</el-carousel-item>
						<el-carousel-item v-if="banner_pic.length == 0">
							<div class="block divimage"><p>{{infolang.nopicture}}</p></div>
						</el-carousel-item>
					</el-carousel>
				</el-col>
			</el-row>
		</el-card>		
		<el-card class="box-card" shadow="hover" v-loading="describeloading" v-show="active == 2">
			<div slot="header" class="clearfix">
				<span>{{infolang.describe }}</span>
			</div>
			<div id="editor" ref="editor" style="margin-top:-10px" class="diveditor"></div>
		</el-card>
		<el-row v-if="!btndisabled" class="footerhandler">
			<el-col :span="active == 0 ? 8 : 5" style="color:transparent;">1</el-col>
			<el-col :span="4" class="submitBtn_cancel" v-if="active > 0"><div @click="pervstep">{{infolang.pervstep}}</div></el-col>
			<el-col :span="4" class="submitBtn_orange" v-if="active < 2"><div @click="nextstep">{{infolang.nextstep}}</div></el-col>
			<el-col :span="4" class="submitBtn" v-if="active == 2"><div @click="saveorder">{{infolang.savecargo}}</div></el-col>
		</el-row>
		<dialogwin ref="dialogwin" @dialogsrue="dialogsrue"></dialogwin>
		<dialogwin ref="dialogwin1" @dialogsrue="dialogsrue"></dialogwin>
		<dialogwin ref="dialogwin2" @dialogsrue="dialogsrue"></dialogwin>
	</div>
</template>

<script>
import Utils from '../../lib/util.js';
import maininfo from '@/components/tools/maininfo.vue';
import dialogwin from '@/components/tools/dialogwin.vue';
import tableui from '@/components/table/tablegrid.vue';
import E from 'wangeditor';
export default {
	components: {
		maininfo,
		dialogwin,
		tableui
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			active:0,
			divclass:'addmeals',
			orderinfo:{
				cargotype:"1",
			},
			l_id:'',
			loading:false,
			btndisabled:false,
			isload:false,
			infolang:{},
			windowHeight: window.innerHeight - 150,
			t_id:'',
			pagetranscol:'',
			speclist:[],
			stufflist:[],
			type:'商品管理',
			cargotypelist:[
				{label:'普通商品',value:'1'},
				{label:'套餐商品',value:'2'},
				{label:'称重商品',value:'3'}
			],
			combolist:[
				{m_name:'',combotype:'1',sortmaxcount:0,combocargolist:[],ismustrepeat:0}
			],
			combotypelist:[
				{label:'固定搭配',value:'1'},
				{label:'可选搭配',value:'0'}
			],
			curpkval:'',
			combochange:1,
			defaultcombo:{m_name:'',combotype:'1',sortmaxcount:0,combocargolist:[],ismustrepeat:0},
			editor: {},
			describeloading:false,
			picloading:false,
			cargotype:'',
			searchpiclist: [],
			banner_piclist: [],
			search_pic:'',
			banner_pic:[],
			describe:'',
			iscopy:0
		}
	},
	created() {
		if(this.item.l_tabevent!=''&&this.item.l_tabevent!=undefined)
			this.l_id=this.item.l_tabevent;
		else
			this.l_id=this.item.l_id;
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/baseinfo/addmeals.scss');
		this.init();
	},
	methods:{
		init(){
			this.isload=false;
			if (this.urlparam != undefined) {
				this.type=this.item.l_tablename;
				if(this.urlparam.iscopy!=undefined)
					this.iscopy=this.urlparam.iscopy;
				if (this.urlparam.pkval != undefined) {
					this.curpkval = this.urlparam.pkval;
				}
			}
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('addmeals',this).then(res=>{
				//debugger
				if(res.state=='1')
				{
					that.infolang=that.$lang.label.addmeals;
					that.cargotypelist.forEach(e=>{
						if(that.infolang[e.label]!=undefined)
							e.label=that.infolang[e.label];
					});
					that.combotypelist.forEach(e=>{
						if(that.infolang[e.label]!=undefined)
							e.label=that.infolang[e.label];
					});
					that.isload=true;	
				}	
				if(that.curpkval!='')//加载口味详情
					that.GetOrderInfo();
				else
					that.GetPageLayout();
			});
		},
		//获取商品信息
		GetOrderInfo(){
			var that=this;
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			var paraminfo={
				pkval:this.curpkval,
				l_id:this.l_id
			}
			debugger
			this.$apipost.get.GetOrderInfoByLid({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					//debugger
					if(res.main!=undefined){
						if(res.main.addinfo!=undefined){
							if(res.main.addinfo!="")
								that.stufflist=JSON.parse(res.main.addinfo);
							delete res.main.addinfo;
						}
						if(res.main.tasteinfo!=undefined)
						{
							if(res.main.tasteinfo!="")
								that.speclist=JSON.parse(res.main.tasteinfo);
							delete res.main.tasteinfo;	
						}
						if(that.iscopy=='1')
							res.main.cno='';
						that.orderinfo=res.main;
					}
					if(res.combolist!=undefined){
						res.combolist.forEach(e=>{
							if(e.combocargolist!=undefined)
								e.combocargolist=JSON.parse(e.combocargolist);
						});
					}
					that.combolist=res.combolist;
					
					that.GetPageLayout();
				} else
					this.$tool.message(that.$lang.label.public.getinfofailed, "0");
			});
		},
		GetPageLayout(){
			var that = this;
			//this.truncatepage();
			this.$tool.loading(that.$lang.label.public.loading, this.divclass);
			//判断是哪种类型的下单功能,显示对应组件
			this.$apipost.get.GetTransFormat({
				p_mode: this.type
			}).then(res => {
				//debugger
				this.$tool.loadingclose();
				var t_id="",pagetranscol="";
				if (res.state == '1') {
					if (res.set != undefined) {
						if(res.set.t_id!=undefined)
						{
							t_id = res.set.t_id;
							pagetranscol=res.set.pagetranscol;
							
							that.$nextTick(function(){
								that.$refs['maininfo_'+that.l_id].init({
									pkval:that.curpkval,
									type:that.type,
									orderinfo:that.orderinfo,
									syscol: res.set.t_syscol,
									t_id: t_id
								});
							});
						}
					}
				}
				that.t_id=t_id;
				that.pagetranscol=pagetranscol;
				if(that.orderinfo!='')
					that.orderinfo = that.$tool.TransOrderInfo(pagetranscol, that);
			});
		},
		//添加套餐组
		addcomboset(){
			this.combolist.push(JSON.parse(JSON.stringify(this.defaultcombo)));
		},
		//选择常用规格组
		openspec(){
			var that=this;
			this.$apipost.get.GetLinkInfo({ l_id:672 }).then(res => {
				//debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin.init({item:paramitem,title:that.infolang.selecttaste});
				} else that.$tool.message(this.$lang.public.fundisabled, 0);
			});
		},
		//选择加料组
		openstuff(){
			var that=this;
			this.$apipost.get.GetLinkInfo({ l_id:677 }).then(res => {
				//debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin1.init({item:paramitem,title:that.infolang.selectstuff});
				} else that.$tool.message(this.$lang.public.fundisabled, 0);
			});
		},
		//选择商品
		openselectcargo(index){
			var that=this;
			this.$apipost.get.GetLinkInfo({ l_id:576 }).then(res => {
				debugger
				if (res.info != undefined) {
					var paramitem=res.info;
					paramitem.iswin=true;
					that.$refs.dialogwin2.init({item:paramitem,title:that.infolang.selectcargo,callbackparam:{index:index}});
				} else that.$tool.message(this.$lang.public.fundisabled, 0);
			});
		},
		dialogsrue(e){
			//读取商品
			var that=this;
			if(e.l_id==672){//规格组
				if(e.rows!=undefined)
				{
					var list=JSON.parse(JSON.stringify(that.speclist));
					e.rows.forEach(r=>{
						var isexists=list.filter(function(o){
							return o.t_type==r.t_type;
						});	
						if(r.list.length>0&&isexists.length==0){
							var li=JSON.parse(r.list);
							li.forEach(t=>{
								list.push({t_type:r.t_type,t_name:t.t_name,addprice:t.price});
							});
						}
					});
					that.speclist=list;
				}
			}
			if(e.l_id==677){//加料
				if(e.rows!=undefined)
				{
					//debugger
					var list=JSON.parse(JSON.stringify(that.stufflist));
					e.rows.forEach(r=>{
						var isexists=list.filter(function(o){
							return o.a_type==r.a_type;
						});	
						if(r.list!=''&&isexists.length==0){
							var li=JSON.parse(r.list);
							li.forEach(t=>{
								t.a_type=r.a_type;
								t.ismul1=r.ismul1;
								t.ismul=r.ismul;
								list.push(t);
							});
						}
					});
					//debugger
					that.stufflist=list;
				}
			}
			if(e.l_id==576){//选择商品
				if(e.rows!=undefined)
				{
					if(e.callbackparam!=undefined){
						var oldlist=JSON.parse(JSON.stringify(that.combolist[e.callbackparam.index].combocargolist));
						e.rows.forEach(r=>{
							if(r.p_type=='1'){ //只能普通商品
								r.num='';
								r.comboprice='';
								if(that.combolist[e.callbackparam.index].combotype=='1')
									r.required=true;
								else
									r.required=false;
								var isexists=oldlist.filter(function(o){
									return o.cno==r.cno;
								});	
								if(isexists.length==0)
									oldlist.push(r);
							}
						});
						that.combolist[e.callbackparam.index].combocargolist=oldlist;
						this.$nextTick(function(){
							that.combochange=parseInt(that.combochange)+1;
						});
					}
				}
			}
		},
		//加载图片
		GetCargoPic(){
			var that=this;
			if(that.curpkval!=''){
				debugger
				if(that.banner_pic.length==0&&that.search_pic==''){
					//this.$tool.loading('正在读取图片','cargoinfo');
					this.picloading=true;
					this.$apipost.get.GetCargoPic({pkcno:that.orderinfo.pkcno,cargotype:this.cargotype}).then(res => {
						this.picloading=false;
						//this.$tool.loadingclose();
						if(res.state=='1'){
							if(res.banner_pic!=undefined)
								that.banner_pic=res.banner_pic;
							if(res.search_pic!=undefined)
								that.search_pic=res.search_pic;
						}
					});
				}
			}
		},
		//获取商品描述内容
		GetCargoDescribe(){
			var that=this;
			if(that.curpkval!=''){
				this.describeloading=true;
				this.$apipost.get.GetCargoDescribe({cargo_id: that.curpkval,isedit:1}).then(res => {
					this.describeloading=false;
					if(res.state=='1'){
						that.initEditor(res.describe);
					}else{
						that.initEditor();
					}
				});
			}
		},
		//初始化富文本框内容
		initEditor(html) {
			this.editor = new E(this.$refs.editor);
			this.editor.config.height = window.innerHeight - 360;
			this.editor.config.uploadImgShowBase64 = true;
			this.editor.config.uploadImgMaxSize = 1 * 1024 * 1024;
			this.editor.config.excludeMenus = ['emoticon', 'video', 'undo', 'redo', 'todo'];
			this.editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
			this.editor.config.uploadFileName = 'fileupload';
			this.editor.config.showLinkImg = false;
			this.editor.config.placeholder =this.infolang.describeempty;
			this.editor.create();
			if(html!=undefined)
				this.editor.txt.html(html);
		},
		//本地预览图片
		getLocalImg(file, type) {
			// 获取上传图片的本地url，用于上传前的本地预览
			//debugger
			var postfix = file.name.substring(file.name.lastIndexOf('.'), file.name.length);
			var that = this;
			let reader = new FileReader();
			reader.readAsDataURL(file.raw);
			reader.onload = () => {
				if (type == 1) that.search_pic = { src: reader.result, postfix: postfix };
				else 
				{
					var list=that.banner_pic.filter(function(b) {
						return b.name == file.name;
					});
					if(list.length==0)
						that.banner_pic.push({name:file.name,src: reader.result, postfix: postfix });
				}
			};
		},
		//上传附件改变时
		searchPicChange(file, fileList) {
			var that = this;
			if (fileList.length > 0) {
				var list = [];
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 1;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过1M,不允许上传', 0);
						this.$refs.upload.abort(e);
					} else {
						var list=that.searchpiclist.filter(function(b) {
							return b.name == e.name;
						});
						if(list.length==0){
							that.searchpiclist.push(e);
							that.getLocalImg(e, 1);
						}	
					}
				});
			}
		},
		//移除上传的文件
		delfile(index) {
			//debugger;
			if(this.searchpiclist[index]!=undefined){
				this.$refs.upload.abort(this.searchpiclist[index]);
				this.searchpiclist.splice(index, 1);
			}
			this.search_pic = '';
		},
		//上传轮播图
		BannerChange(file, fileList) {
			var that = this;
			if (fileList.length > 0) {
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 1;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过1M,不允许上传', 0);
						this.$refs.banner_pic.abort(e);
					} else {
						var list=that.banner_piclist.filter(function(b) {
							return b.name == e.name;
						});
						if(list.length==0){
							that.banner_piclist.push(e);
						}
						
					}
				});
				that.getLocalImg(file, 2);
			}
		},
		//删除轮播图
		delbanner(index) {
			//debugger;
			if(this.banner_piclist[index]!=undefined){
				this.$refs.banner_pic.abort(this.banner_piclist[index]);
				this.banner_piclist.splice(index, 1);
			}
			var list=[];
			this.banner_pic.splice(index, 1);
			if(this.banner_pic.length==0)
				this.banner_piclist=[];
		},
		//套餐组合类型更改
		combotypechange(item,index){
			var ischecked=false;
			if(item.combotype=='1'){//固定搭配
				ischecked=true;
			}
			else if(item.combotype=='0'){//可选搭配
				if(item.ismustrepeat==0||!item.ismustrepeat){
					for(var i=0;i<item.combocargolist.length;i++){
						if(item.combocargolist[i]['num']!=''){
							if(Number(item.combocargolist[i]['num'])>1){
								item.ismustrepeat=true;
								break;
							}
						}
					}
				}
			}
			item.combocargolist.forEach(e=>{
				e.required=ischecked;
			});
		},
		changerequired(e,item,idx,itemindex){
			if(e){
				var list=item.combocargolist.filter(function(b){
					return b.required==true;
				});
				if(item.sortmaxcount<list.length)
				{
					this.$tool.message(this.infolang.combolimit,"0");
					item.combocargolist[idx].required=!e;
				}
			}
			
			var that=this;
			this.$nextTick(function(){
				that.combochange=parseInt(that.combochange)+1;
			});
		},
		checkrequired(item,itemindex){
			var list=item.combocargolist.filter(function(b){
				return b.required==true;
			});
			if(item.sortmaxcount<list.length)
			{
				this.$tool.message(this.infolang.comboless,"0");
				item.sortmaxcount='';
			}
		},
		checkrepeat(item,colname){
			debugger
			if((!item.ismustrepeat||item.ismustrepeat==0)&&item.combotype=='0'){
				if(item.combocargolist.length>0){
					for(var i=0;i<item.combocargolist.length;i++){
						item.combocargolist[i][colname]=1;
					}
				}
			}
			this.$forceUpdate();
		},
		inputchange(item,row,colname){
			debugger;
			if(item!=undefined){
				if(colname=='num'){
					if(item.ismustrepeat==0&&item.combotype=='0'){
						if(row[colname]!=''){
							if(!isNaN(Number(row[colname]))){
								if(Number(row[colname])>1){
									this.$tool.message(row.cname+this.infolang.repeatnummore,"0");
									row[colname]='';
								}
							}
						}
					}
				}
			}
			// debugger;
			this.$forceUpdate();
		},
		//更改模块顺序
		changechunkindex(list,index,type){
			//debugger
			var that=this;
			if(type=='top'){
				if(index==0)
					return false;
				else
				{
					var temp=JSON.parse(JSON.stringify(list[index]));
					var temp1=JSON.parse(JSON.stringify(list[index-1]));
					list[index-1]=temp;
					list[index]=temp1;
					this.$nextTick(function(){
						that.combochange=parseInt(that.combochange)+1;
					});
				}	
			}
			if(type=='bottom'){
				if((index+1)==list.length)
					return false;
				else
				{
					var temp=JSON.parse(JSON.stringify(list[index]));
					var temp1=JSON.parse(JSON.stringify(list[index+1]));
					list[index+1]=temp;
					list[index]=temp1;
					this.$nextTick(function(){
						that.combochange=parseInt(that.combochange)+1;
					});
				}
			}
		},
		delchunk(list,index){
			list.splice(index,1);
		},
		//检测商品必填信息
		checkInfo() {
			var isgo = true;
			if (this.active == 0) {
				//检测必填项
				if(this.speclist.length==0&&this.orderinfo.cargotype=='1'){
					isgo=false;
					this.$tool.message(this.infolang.cargospecempty, 0);
				}
				if(isgo){
					if(this.orderinfo.cargotype=='2'){//套餐商品
						if(this.combolist.length>0){
							for(var i=0;i<this.combolist.length;i++){
								if(this.combolist[i].m_name==''){
									isgo=false;
									this.$tool.message(this.infolang.m_nameempty, 0);
									break;
								}
								if(this.combolist[i].combocargolist.length==0){
									isgo=false;
									this.$tool.message(this.infolang.combocargolistempty, 0);
									break;
								}
								else{
									for(var j=0;j<this.combolist[i].combocargolist.length;j++){
										
										if(this.combolist[i].combocargolist[j].num==''||this.combolist[i].combocargolist[j].num=='0'){
											isgo=false;
											this.$tool.message(this.infolang.combonumempty, 0);
											break;
										}
										if(this.combolist[i].combocargolist[j].comboprice==''){
											this.combolist[i].combocargolist[j].comboprice=0;
										}
										if(this.combolist[i].combotype=='1'){
											this.combolist[i].combocargolist[j].isrepeat=true;
										}
									}
									if(this.combolist[i].combotype=='1'){
										this.combolist[i].sortmaxcount=this.combolist[i].combocargolist.length;
									}
								}
								if(!isgo)
								 break;
							}
						}
					}
					debugger
				}
			}
			return isgo;
		},
		//下一步
		nextstep() {
			var that=this;
			if (this.active == 0) {
				//加载图片
				if (this.checkInfo()) {
					this.GetCargoPic();
				}
				else return false;
				
			} else if (this.active == 1) {
				//if (this.checkInfo()) {
					debugger
					if (this.editor.config == undefined) {
						if(this.curpkval=='')
							this.initEditor();
						else
							this.GetCargoDescribe();
					}
				// } else return false;
			}
			if (this.active < 2) this.active = this.active + 1;
		},
		//上一步
		pervstep() {
			this.active = this.active - 1;
		},
		saveorder(){
			var that=this;
			//debugger
			//保存main的基本信息
			var that=this;
			var orderinfo=JSON.parse(JSON.stringify(this.orderinfo));
			if(this.speclist.length>0)
				orderinfo.p_remark=JSON.stringify(this.speclist);
			if(this.stufflist.length>0)
				orderinfo.p_remark1=JSON.stringify(this.stufflist);
			if(this.combolist.length>0&&this.orderinfo.cargotype=='2')
				orderinfo.p_content=JSON.stringify(this.combolist);
			//this.orderinfo=orderinfo;
			orderinfo=this.$tool.getOrderinfo(this.$refs['maininfo_'+this.l_id]._data,this.curpkval,this,orderinfo);
			if(orderinfo!=''){
				orderinfo.expresscode=this.orderinfo.cargotype;
				if(this.iscopy=='0')
					orderinfo.editid=this.curpkval;
				orderinfo.t_id=that.t_id;
				orderinfo.u_userid=localStorage.getItem('userid');
				this.btndisabled=true;
				this.$tool.loading(that.$lang.label.public.saving, this.divclass);
				this.$apipost.post.SaveInfo({ paraminfo: orderinfo }).then(res => {
					if (res.state == '1') {
						that.orderinfo.id=res.pkval;
						that.SavePic();
					}
					else{
						this.$tool.loadingclose();
						that.btndisabled=false;
						if(res.errorcode!=undefined){
							if(that.infolang[res.errorcode]!=undefined)
								this.$tool.message(that.infolang[res.errorcode], "0");
							else
								this.$tool.message(res.message, "0");	
						}
						else
							this.$tool.message(res.message, "0");
						if(res.localfilename!=undefined){
							if(res.localfilename!=''){
								that.$tool.downfile(that,res.localfilename,res.tempbatch);
							}
						}	
					}
				});
			}
			//保存图片，并同步到不同语言的商品
			//保存详情描述
		},
		//取消保存
		cancel(){
			Utils.$emit('handleRermove', localStorage.getItem('tabname'));
		},
		//保存图片/轮播图
		SavePic() {
			var that = this;
			if(this.search_pic!=''||this.banner_pic.length>0){
				var paraminfo = {
					search_pic: this.search_pic,
					banner_pic: this.banner_pic,
					cargotype:this.cargotype
				};
				this.$apipost.post.SaveCargoPic({ paraminfo: paraminfo, cargo_id: that.orderinfo.id }).then(res => {
					if (res.state == '1') {
						that.SaveDescribe();
					} else {
						that.btndisabled=false;
						that.$message.closeAll();
						this.$tool.message(res.message, 0);
					}
				});
			}
			else
				this.SaveDescribe();
		},
		//保存商品描述
		SaveDescribe() {
			var that = this;
			this.describe = this.editor.txt.html();
			if(this.describe!=''){
				this.$apipost.post.SaveCargoDescribe({ describe: this.describe,cargo_id: that.orderinfo.id,cargotype:this.cargotype }).then(res => {
					this.btndisabled=false;
					that.$message.closeAll();
					if (res.state == '1') {
						this.$tool.message(that.$lang.label.public.savesuccess, "1");
						setTimeout(function() {
							that.cancel();
						}, 1000);
					} else {
						debugger
						this.$tool.message(res.message, 0);
					}
				});
			}
			else{
				this.$tool.message(that.$lang.label.public.savesuccess, "1");
				setTimeout(function() {
					that.cancel();
				}, 1000);
			}
		},
	}
}	
</script>

<style>
</style>